class Monitoring.Views.KeywordView extends Backbone.View
  template: JST["backbone/templates/monitoring/label_admin/keywords"]

  events :
    'click #btn-add-keyword': 'onAddKeyword'
    'click #btn-clean-keyword': 'clean'
    'keypress .add-keyword': 'onKeypress'

  defaults:
    entityName: 'default',
    attributeName: 'default'
    title: ''
    subtitle: ''
    keywordClass: ''
    placeholder: 'Add keywords'
    keywordId: 'add-keyword'
    allowedKeywords: undefined
    autoComplete: undefined
    counterEnabled: false
    customErrorMessage: ''
    addedKeywordsTemplate: JST["backbone/templates/monitoring/label_admin/default_added_keywords"]
    afterRender: ->

  initialize: (@options = {}) ->
    @options = _.defaults(@options, @defaults)
    @options.placeholder = I18n.t('monitoring.reply_blacklist.keywords_comma')
    @keywords = @options.keywords
    @onAddKeywordCallBack = @options.onAddKeyword || () ->
    @onRemoveKeywordCallBack = @options.onRemoveKeyword || () ->

  render: ->
    @$el.html(@template(values: @options)).addClass('no-overflow-list')
    @$el.find('.added').html(@options.addedKeywordsTemplate(keywords: @keywords.toJSON(), values: @options))
    @$el.find('.counter').html("(#{@getKeywordCount()})") if @options.counterEnabled
    @$el.find('.added i').on('click', @onRemoveKeyword)
    @options.afterRender(@$el)
    @_autoComplete() if @options.autoComplete
    return this

  onKeypress: (event) =>
    @trigger('on_keypress')
    if event.which is 13 #Enter key
      @onAddKeyword(event)

  _autoComplete: =>
    activeKeywords = _.map(this.keywords.getActiveKeywords(), (k) ->  return k.get('name'))
    available_keywords = _.difference(@options.autoComplete.keywords, activeKeywords);
    @_getComponent().typeahead({source: available_keywords})

  destroy: ->
    this.remove()
    return false

  onRemoveKeyword: (event) =>
    event.preventDefault()
    text = $(event.currentTarget).prev().text()
    @keywords.removeByName(text)
    @onRemoveKeywordCallBack()
    @render()

  updateKeywords: (allowedKeywords, autoComplete) ->
    @options.allowedKeywords = allowedKeywords
    @options.autoComplete = autoComplete
    previous_text = @written_text()
    @render()
    @$el.find('.add-keyword')[0].value = previous_text
    @_getComponent().focus()
    @_getComponent().trigger('keyup')

  # RegEx: (("[^"]+") +AND +("[^"]+"))|("[^"]+")|([^,"]+)
  # (("[^"]+") +AND +("[^"]+")) => "hola" AND "chau"
  # ("[^"]+") => "hola, que tal" or "hola que tal"
  # ([^,"]+) => hola
  onAddKeyword: (event) =>
    event.preventDefault()
    _.each(@_getComponent().val().match(/(("[^"]+") +AND +("[^"]+"))|("[^"]+")|([^,"]+)/g), (keyword) =>
      keyword = keyword.trim()
      if keyword != '' and keyword != ',' and keyword != '","' # Ignore corner cases
        @addKeyword(keyword)
    )
    @onAddKeywordCallBack()

  addKeyword: (text) ->
    if text != '' and !@keywords.containsByName(text) and @canInsertThisKeyword(text)
      @keywords.addKeyword(new Monitoring.Models.Keyword(name: text, id: @_getIdByNameOrNull(text)))
      @render()
    else
      @_showErrorIfNecessary()
    @_getComponent().focus()

  _getComponent: ->
    @$el.find("##{@options.keywordId}")

  _showErrorIfNecessary: ->
    if @options.allowedKeywords != undefined
      $formSearch = @$el.find('.form-search')
      $formSearch.find('#custom_message').remove()
      $formSearch.addClass('error')
      $formSearch.append("<span id='custom_message' for='whitelist-cbo' generated='true' class='validation'>#{@options.customErrorMessage}</span>");

  _getIdByNameOrNull: (name) ->
    allowedKeyword = _.find(@options.allowedKeywords, (k) -> k.name == name)
    return if allowedKeyword then allowedKeyword.id else null

  canInsertThisKeyword: (keyword) ->
    return @options.allowedKeywords == undefined or _.any(@options.allowedKeywords, (k) -> k.name == keyword)

  getKeywordsAttributes: ->
    return @keywords.map((keyword) =>
      { 'name': keyword.get('name'), 'id': keyword.get('id'), '_destroy': keyword.get('destroy') }
    )

  getKeywordCount: ->
    return @keywords.size()

  getKeywordNames: ->
    @keywords.map (k) -> k.get('name')

  getActiveKeywordNames: ->
    @keywords.getActiveKeywords().map (k) -> k.get('name')

  clean: ->
    @$el.find('.added').empty()
    @keywords.reset()

  written_text: ->
    @$el.find('.add-keyword')[0].value
